// @ts-nocheck

import React, { useCallback, useState } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../../client';
import SpinePlayer from '../../../../../components/SpinePlayer';
import type { SpineAnimationId } from '../../../../../types/animations';
import { type SoundId } from '../../../../../types/sounds';

const Wrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100vh;
  height: 100vh;

  ${!Target.__MOBILE__
    ? css`
        width: 100%;
        height: 100%;
      `
    : undefined}

  z-index: 9999999;
  transform: translate(-50%, -50%);

  display: flex;
  justify-content: center;
  align-items: center;

  ::before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
  }

  cursor: pointer;
`;

const SpinePlayerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const StyledSpinePlayer = styled(SpinePlayer)`
  position: relative;
`;

const AnimationSize = Target.__MOBILE__ ? 1300 : 1500;

type WelcomeAnimationPropsType = {
  className?: string;
  animationId: SpineAnimationId;
  onAnimationEnd: () => void;
  soundId?: SoundId;
};

const WelcomeAnimation = ({ className = '', animationId, onAnimationEnd, soundId }: WelcomeAnimationPropsType) => {
  const [shouldRender, setShouldRender] = useState(true);

  const onClick = useCallback(() => {
    onAnimationEnd();
    setShouldRender(false);
  }, [onAnimationEnd]);

  return shouldRender ? (
    <Wrapper className={className} $isMobile={Target.__MOBILE__} onClick={onClick}>
      <SpinePlayerWrapper>
        <StyledSpinePlayer
          animationId={animationId}
          width={AnimationSize}
          height={AnimationSize}
          onEndAnimation={onAnimationEnd}
          hideMuteButton
          preventCutAnim
          soundId={soundId}
        />
      </SpinePlayerWrapper>
    </Wrapper>
  ) : null;
};

export default WelcomeAnimation;
